var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutIconLst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "outIconLst_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 282",
    transform: "translate(-.416)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h72v72H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "outIconLst_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 385",
    transform: "translate(-.416)",
    fill: "none",
    d: "M0 0h72v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.416)",
    clipPath: "url(#outIconLst_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "OutIcon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 383",
    clipPath: "url(#outIconLst_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 738",
    d: "M43.503 47.944V27.996h8.664v-2.868h3.481v2.868h8.765V45.53q0 1.649-.813 2.081a9.524 9.524 0 01-3.532.381q-.686 0-3-.051l-.991-3.527q.661 0 2.566.1h.559a4.449 4.449 0 001.55-.152.58.58 0 00.254-.482V31.092h-5.587q-.1 1.168-.305 2.284a39.184 39.184 0 013.354 3.02 23.238 23.238 0 012.413 2.893l-2.49 3.2a27.574 27.574 0 00-4.293-5.845 14.1 14.1 0 01-2.388 3.451 12.514 12.514 0 01-2.617 2.208l-2.007-2.859a10.171 10.171 0 003.251-3.277 14.339 14.339 0 001.6-5.076h-5.03v16.853z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 552",
    d: "M28.66 52.844H9.038a3 3 0 010-6H28.66a7.4 7.4 0 007.276-7.5v-.906a7.4 7.4 0 00-7.276-7.5H13.307a3 3 0 010-6H28.66a13.318 13.318 0 0113.1 13.5v.906a13.319 13.319 0 01-13.1 13.5",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 553",
    d: "M8.877 30.938a2.868 2.868 0 01-2.231-1.072 3.063 3.063 0 01.359-4.226l12.677-10.96a2.851 2.851 0 014.1.37 3.064 3.064 0 01-.359 4.226l-12.677 10.96a2.849 2.849 0 01-1.869.7",
    fill: "#040000"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 554",
    d: "M21.551 41.898a2.847 2.847 0 01-1.869-.7L7.005 30.236a3.064 3.064 0 01-.359-4.226 2.851 2.851 0 014.1-.37L23.423 36.6a3.064 3.064 0 01.359 4.226 2.87 2.87 0 01-2.231 1.072",
    fill: "#040000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutIconLst);
export default __webpack_public_path__ + "static/media/outIconLst.cff6fb7ab23d24e8.svg";
export { ForwardRef as ReactComponent };